import React from 'react';
import { ReportSection, ReportSubsection } from '../framework';

export const DecisionSection: React.FC = () => {
  return (
    <ReportSection id="decision" title="Making Your Decision" subtitle="Questions to discuss">
      <ReportSubsection title="Questions to Discuss">
        <ol className="list-decimal list-inside space-y-3 text-gray-700">
          <li><strong>How do you feel about being landlords?</strong> Even with a property manager,
          you're still the owner. Problems escalate to you.</li>
          <li><strong>Will you need access to this money in the next 10 years?</strong> Real estate
          is illiquid. Selling takes months and costs 6%.</li>
          <li><strong>What's your gut feeling on Newport Beach vs. the stock market?</strong> Sometimes
          intuition captures knowledge that's hard to articulate.</li>
          <li><strong>How would you split responsibilities if you keep it?</strong> If there are multiple
          owners, this matters.</li>
          <li><strong>How important is simplicity in your financial life right now?</strong> Sometimes
          the right choice is the one that removes complexity.</li>
          <li><strong>What does this property mean to you beyond the numbers?</strong> This was your
          mother's house. If keeping it carries emotional value—or if holding onto it feels like a
          burden—that matters. Spreadsheets can't capture everything.</li>
        </ol>
      </ReportSubsection>

      <ReportSubsection title="When to Revisit This Analysis">
        <p className="text-gray-700 mb-4">
          This isn't a one-time decision. You should revisit when:
        </p>

        <ul className="list-disc list-inside text-gray-600 space-y-1 mb-4">
          <li>Property values change significantly (±20%)</li>
          <li>Your personal circumstances change (new job, moving, inheritance)</li>
          <li>Tax laws change (depreciation rules, capital gains)</li>
          <li>At least annually to reflect new market data</li>
        </ul>
      </ReportSubsection>

      <div className="bg-gray-100 p-6 mt-8 text-center">
        <p className="text-gray-600 mb-4">Want to explore different scenarios and assumptions?</p>
        <p className="text-lg font-medium text-gray-900">
          Try the <strong>Full Simulator</strong> tab for complete control over all variables.
        </p>
      </div>
    </ReportSection>
  );
};
